import React, {useEffect, useState} from 'react';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Etiqueta from './etiquetaObligatorio/Etiqueta';

function PhoneV2({
  label,
  value,
  setValue,
  international,
  disabled = false,
  required,
}) {
  return (
    <React.Fragment>
      {label && (
        <Etiqueta
          texto={
            <div
              style={{
                display: 'inline-block',
                marginBottom: 5,
                fontWeight: 'bold',
              }}>
              {label}
            </div>
          }
          obligatorio={required}
        />
      )}
      {international ? (
        <PhoneInput
          country={'py'}
          value={value}
          onChange={setValue}
          placeholder="Número de teléfono"
          inputStyle={{height: 33, borderRadius: 0}}
          containerStyle={{borderRadius: 0, marginBottom: '15px'}}
          inputProps={{
            disabled: disabled,
          }}
        />
      ) : (
        <PhoneInput
          countryCodeEditable={false}
          onlyCountries={['py']}
          country={'py'}
          value={value}
          onChange={phone => {
            if (phone?.length < 13) {
              setValue('+' + phone);
            }
          }}
          placeholder="+5959xxxxxxxx"
          disableDropdown={true}
          inputProps={{value: value, disabled: disabled}}
          inputStyle={{height: 33, borderRadius: 0, width: '100%'}}
          containerStyle={{borderRadius: 0, marginBottom: '15px'}}
        />
      )}
    </React.Fragment>
  );
}

export {PhoneV2};
